import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../../common/Table';
import ConstElement from '../../common/ConstElement';
import CommentJobApply from './CommentJobApply';
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Rater from 'react-rater'
import 'react-rater/lib/react-rater.css'

export default class EditJobApply extends Component {
    constructor(props) {
        super(props);
        this.state = {
                jobApply: {},
                messages: [],
                current_status: '',
                current_evaluation: 5,
                disable_all_actions: false,
        }
        this.saveData = this.saveData.bind(this);
        this.setData = this.setData.bind(this);
        this.getData = this.getData.bind(this);
        this.handleInptChange = this.handleInptChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.changeStatus = this.changeStatus.bind(this);
        this.renderChangeStatus = this.renderChangeStatus.bind(this);
        this.renderEvaluateStaff = this.renderEvaluateStaff.bind(this);
        this.renderRejectBtn = this.renderRejectBtn.bind(this);
        this.handleReject = this.handleReject.bind(this);
        this.handleChangeStar = this.handleChangeStar.bind(this);
        this.changeEvaluation = this.changeEvaluation.bind(this);
        this.renderJobApplyStatus = this.renderJobApplyStatus.bind(this);
        this.scrollToComment = this.scrollToComment.bind(this);
    }

    /**
     * Init data
     */
    componentWillMount() {
        if (this.props.match.params.hasOwnProperty('id')) {
            const jobApplyId = this.props.match.params.id
            //Read job apply
            axios.post('/api/houjin/jobapplys/read/' + jobApplyId).then(response => {})
            //Read message
            axios.post('/api/houjin/messages/read/' + jobApplyId).then(response => {})

            //Edit jobapply
            axios.get('/api/houjin/jobapplys/comments/' + jobApplyId).then(response => {
                if (response.data && response.data.message_details) {
                    this.setState({
                        messages: response.data.message_details
                    })
                }
            })

            axios.get('/api/houjin/jobapplys/' + jobApplyId).then(response => {
                this.setData(response.data);
                this.setState({disable_all_actions: response.data.disable_all_actions});
                this.setState({current_status: response.data.status});
            }).catch(() => {
                this.props.history.push('/_404');
            })
        }
    }
    // componentDidMount() {
    //     this.scrollToComment();
    // }
    scrollToComment() {
        const keySearch_str = this.props.location.search.substring(1);
        let keySearch_arr = {};
        if (keySearch_str) {
            keySearch_arr = JSON.parse('{"' + decodeURI(keySearch_str.replace(/&/g, "\",\"").replace(/=/g, "\":\"")) + '"}');
            if (keySearch_arr.from === 'message') {
                // const headerHeight = document.getElementsByClassName('navbar')[0].clientHeight
                const ankerDom = document.getElementById('comment-area');
                window.scroll(0, 0);
                if (ankerDom) {
                    // window.scrollTo( 0, monthAnker.getBoundingClientRect().top);
                    window.scrollBy({
                        top: ankerDom.offsetTop,
                        behavior: 'smooth'
                    })
                }

            }
        }
    }

    /**
     * Set data of jobApply
     * data: Object JobApply
     */
    setData(data) {
        this.setState({
            jobApply: data
        })
    }

    /**
     * Get data of jobApply
     */
    getData() {
        return this.state.jobApply;
    }

    /**
     * Listen change input
     * event: Object input
     */
    handleInptChange(event) {
        let jobApplyData = Object.assign({}, this.state.jobApply);
        jobApplyData[event.target.name] = event.target.value;
        this.setState({jobApply: jobApplyData});
    }

    fireRedirect(e) {
        e.preventDefault()
        this.props.onHandleRedirect(e.currentTarget.getAttribute('href'));
    }

    /**
     * Call function save data from element parent
     */
    saveData() {
        let jobApply = this.getData();
        //to top
        window.scrollTo(0, 0)
        if (jobApply.hasOwnProperty('id')) {
            axios.post('/api/houjin/jobapplys/edit/' + jobApply.id, jobApply).then(response => {
                if (response.data.success) {
                    this.setState({current_status: this.state.jobApply.status})
                    toast.success(response.data.message)
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }

    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }

    /**
     * Change status = 採用する
     */
    changeStatus(e) {
        e.preventDefault()
        if (window.confirm('この応募を採用してもよろしいですか？')) {
            let jobApply = this.getData();
            //to top
            window.scrollTo(0, 0)
            if (jobApply.hasOwnProperty('id')) {
                axios.post('/api/houjin/jobapplys/accept/' + jobApply.id).then(response => {
                    if (response.data.success) {
                        this.setState({current_status: 1})
                        this.setData(response.data.jobApply);
                        toast.success(response.data.message)
                    } else {
                        Object.keys(response.data.errors).map((key, i) => {
                                if($.isArray(response.data.errors[key])){
                                    response.data.errors[key].map((child, i) => {
                                        toast.error(child)
                                    })
                                } else {
                                    toast.error(response.data.errors[key])
                                }
                            }
                        )
                    }
                }).catch(error => {
                    Object.keys(error.response.data.errors).map((key, i) => {
                            if($.isArray(error.response.data.errors[key])){
                                error.response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(error.response.data.errors[key])
                            }
                        }
                    )
                })
            }
        }
    }

    /**
     * Handle reject jobapply
     */
    handleReject(e) {
        e.preventDefault()
        if (window.confirm('この応募を不採用にしてもよろしいですか？')) {
            let jobApply = this.getData();
            //to top
            window.scrollTo(0, 0)
            axios.get('/api/jobapplys/reject/' + jobApply.id).then(response => {
                if (response.data.success) {
                    this.setState({current_status: 2})
                    toast.success(response.data.message)
                    this.setData(response.data.jobApply);
                } else if (response.data.error) {
                    toast.error(response.data.message)
                    this.setData(response.data.jobApply);
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }

    /**
     * change evaluation staff
     */
    changeEvaluation(e) {
        e.preventDefault()
        $('#evaluationModal').modal('hide');
        let jobApplyData = Object.assign({}, this.state.jobApply);
        jobApplyData['evaluation_staff'] = this.state.current_evaluation;
        this.setState({jobApply: jobApplyData});

        //to top
        window.scrollTo(0, 0)
        if (jobApplyData.hasOwnProperty('id')) {
            axios.post('/api/houjin/jobapplys/evaluation/' + jobApplyData.id, jobApplyData).then(response => {
                if (response.data.success) {
                    toast.success(response.data.message)
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }

    handleChangeStar(event) {
        this.setState({current_evaluation: event.rating});
    }

    /**
     * Render Change status button
     */
    renderChangeStatus() {
        let job = this.state.jobApply.job;
        let jobApply = this.state.jobApply;
        if (this.state.current_status == 1) return;
        if (jobApply.deleted_at) return;
        if (job && job.status == 9) return;
        let isDisable = this.state.disable_all_actions || (job && job.staff_count == job.recruit_count);
        return(
            <button onClick={this.changeStatus} disabled={isDisable} className="btn bg-pink text-white btn-radius btn-lg"><span className="size-inherit">採用</span></button>
        )
    }

    /**
     * Render reject button
     */
    renderRejectBtn() {
        let jobApply = this.state.jobApply;
        if (this.state.current_status == 2) return;
        if (jobApply.deleted_at) return;
        return(
            <button onClick={this.handleReject} disabled={this.state.disable_all_actions} className="btn bg-purple text-white btn-radius btn-lg m-2"><span className="size-inherit">不採用</span></button>
        )
    }

    /**
     * Render Evaluate Staff
     */
    renderEvaluateStaff() {
        //check conditions:
        //1. job.status = 4 (評価待ち) 2. jobApply.status = 1 (採用したワーカ) 3. jobApply.evaluation_staff == null (first time evaluation)
        if(this.state.jobApply.job && this.state.jobApply.job.status == 4
            && this.state.jobApply.evaluation_staff == null
            && this.state.jobApply.status == 1){
            return(
                <div className="d-inline-block m-2">
                    <button data-toggle="modal" data-target="#evaluationModal" className="btn bg-pink text-white btn-radius btn-lg"><span className="size-inherit">ワーカーを評価する</span></button>
                    <div className="modal fade" id="evaluationModal" tabIndex="-1" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content cover-loading-parent">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">ワーカーを評価してください</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body pb-0">
                                    <div className="text-left">
                                        <p className="h5 font-weight-normal">
                                            <span className="font-size-full font-weight-bold mr-2">{this.state.jobApply.staff.nickname} ({this.state.jobApply.staff.firstname + this.state.jobApply.staff.lastname})</span>
                                            <span className="d-inline-block">{this.state.jobApply.staff.age} / {this.state.jobApply.staff.gender_text}</span>
                                        </p>
                                        <div className="h5 font-weight-normal">
                                            <p className="d-inline-block bg-light col-3 col-sm-2 pl-0 pr-0 pt-1 pb-1 text-center rounded mr-3 mb-0">実績</p>
                                            <p className="d-inline-block">{this.state.jobApply.staff.evaluation_count | '0'}件</p>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-sm-12">
                                            <Rater total={5} rating={this.state.current_evaluation} onRate={this.handleChangeStar} />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 text-center mb-4">
                                            相互評価後はコメントが送信できなくなります。
                                    </div>
                                </div>
                                <div className="text-center mb-4">
                                    <button type="button" className="btn border-secondary text-white btn-radius btn-lg h5" data-dismiss="modal"><span className="size-inherit text-body">キャンセル</span></button>
                                    <div className="d-inline-block m-2">
                                        <button type="button" className="btn bg-pink text-white btn-radius btn-lg h5" onClick={this.changeEvaluation} disabled={this.state.current_evaluation > 0 ? '' : 'disabled'}>評価する</button>
                                    </div>
                                </div>
                                <div className="cover-loading block-hidden h5">処理中...</div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        return ''
    }

    renderJobApplyStatus() {
        switch (true) {
            case this.state.jobApply.evaluation_client !== null && this.state.jobApply.evaluation_staff !== null:
                return '作業完了';

            case !!this.state.jobApply.job:
                return this.state.jobApply.job.status_text

            default:
                return '';
        }
    }

    render() {
        return (
            <React.Fragment>
            <div className="row">
                <div className="col-sm-12">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/houjin/home">ダッシュボード</a></li>
                            <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/houjin/jobapplys">応募一覧</a></li>
                            <li className="breadcrumb-item active" aria-current="page">応募編集</li>
                        </ol>
                    </nav>
                </div>
            </div>
            <main id="main">
                <div className="row justify-content-md-center">
                    <div className="col-sm-6 mb-4">
                        <div className="card">
                            <div className="card-header p-4 border-bottom-0">
                                <div className="row">
                                    <h4 className="col-6 mb-0 ml-1">応募編集</h4>
                                    <p class="col-5 col-lg-5 pr-2 text-primary text-right">
                                        <a href={"/houjin/jobs/edit/" + this.state.jobApply.job_id} className="font-weight-normal">
                                            依頼編集画面へ
                                            <span className="dli-chevron-round-right"></span>
                                        </a>
                                    </p>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label"><p className=" h5 font-weight-normal">依頼ID</p></label>
                                    <div className="col-8 col-sm-8">
                                        <label className="col-value text-left text-primary">
                                            <a href={"/houjin/jobs/edit/" + this.state.jobApply.job_id} className="d-inline-block">
                                                <p className="h5 font-weight-normal">{this.state.jobApply.job_id}</p>
                                            </a>
                                            <span className={this.state.jobApply.job ? 'badge bg-pink text-white ml-2 pt-2' : 'd-none'}>{this.renderJobApplyStatus()}</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label"><p className="h5 font-weight-normal">ワーカー</p></label>
                                    <div className="col-8 col-sm-8">
                                        {(this.state.jobApply.staff && this.state.jobApply.staff.firstname && this.state.jobApply.staff.lastname) ?
                                        <label className="col-value text-left w-100">
                                            <p className="h5 font-weight-normal">
                                                <span className="font-size-full">
                                                    {this.state.jobApply.staff.nickname} ({this.state.jobApply.staff.firstname + this.state.jobApply.staff.lastname})
                                                </span>
                                            {this.state.jobApply.staff.confirmed_at ?
                                                <span className="icon-identification font-weight-normal">本人認証済</span>
                                                : ''
                                            }
                                            </p>
                                            <p className="h5 font-weight-normal mb-4">
                                                <span className="d-inline-block">ID：{this.state.jobApply.staff_id} / {this.state.jobApply.staff.age} / {this.state.jobApply.staff.gender_text}</span>
                                            </p>
                                            <div className="h5 font-weight-normal">
                                                <p className="d-inline-block bg-light col-3 col-sm-2 pl-0 pr-0 pt-1 pb-1 text-center rounded mr-3 mb-0">評価</p>
                                                <p className="d-inline-block"><span class="star5_rating" data-rate={Math.round(this.state.jobApply.staff.evaluation_avg)}></span> {this.state.jobApply.staff.evaluation_avg_formatted}</p>
                                            </div>
                                            <div className="h5 font-weight-normal">
                                                <p className="d-inline-block bg-light col-3 col-sm-2 pl-0 pr-0 pt-1 pb-1 text-center rounded mr-3 mb-0">実績</p>
                                                <p className="d-inline-block">{this.state.jobApply.staff.evaluation_count | '0'}件</p>
                                            </div>
                                            <div className="h5 font-weight-normal">
                                                <p className="d-inline-block bg-light col-3 col-sm-2 pl-0 pr-0 pt-1 pb-1 text-center rounded mr-3 mb-0">ｷｬﾝｾﾙ</p>
                                                <p className="d-inline-block">{this.state.jobApply.staff.cancel_apply_count ? this.state.jobApply.staff.cancel_apply_count : 0} 件</p>
                                            </div>
                                        </label>
                                        : ''}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label"><p className="h5 font-weight-normal">住所</p></label>
                                    <div className="col-8 col-sm-8">
                                        <label className="col-value text-left">{this.state.jobApply.pref_name}</label><br/>
                                        <label className="col-value text-left">{this.state.jobApply.city_name}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label"><p className="h5 font-weight-normal">ステータス</p></label>
                                    <div className="col-8 col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="job_applys.status" value={this.state.jobApply.status ? this.state.jobApply.status : ''} staff_count={this.state.jobApply.staff_count} recruit_count={this.state.jobApply.recruit_count} current_status={this.state.current_status} is_disabled={true} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label pr-0"><p className="h5 font-weight-normal">依頼者への<br class="d-block d-sm-none"/>評価</p></label>
                                    <div className="col-8 col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="job_applys.evaluation_client" value={this.state.jobApply.evaluation_client ? this.state.jobApply.evaluation_client : ''} is_disabled={true} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label pr-0"><p className="h5 font-weight-normal">ワーカーへの評価</p></label>
                                    <div className="col-8 col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="job_applys.evaluation_staff" value={this.state.jobApply.evaluation_staff ? this.state.jobApply.evaluation_staff : ''} is_disabled={true} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label"><p className="h5 font-weight-normal">完了フラグ</p></label>
                                    <div className="col-8 col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="job_applys.complete_flag" value={this.state.jobApply.complete_flag ? this.state.jobApply.complete_flag : ''} is_disabled={true} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label"><p className="h5 font-weight-normal">勤務結果</p></label>
                                    <div className="col-8 col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="job_applys.work_result" value={this.state.jobApply.work_result ? this.state.jobApply.work_result : ''} is_disabled={true} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label"><p className="h5 font-weight-normal">報酬</p></label>
                                    <div className="col-8 col-sm-8">
                                        <label className="col-value text-left">
                                            <p className="h5 font-weight-normal">
                                                ¥{this.state.jobApply.job && this.state.jobApply.job.staff_price ? parseInt(this.state.jobApply.job.staff_price).toLocaleString() : 0}
                                            </p>
                                        </label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label"><p className="h5 font-weight-normal">契約形態</p></label>
                                    <div className="col-8 col-sm-8">
                                        <label className="col-value text-left">
                                            <p className="h5 font-weight-normal">
                                                {this.state.jobApply.job ? this.state.jobApply.job.payment_method_text : ''}
                                            </p>
                                        </label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label"><p className="h5 font-weight-normal">応募日</p></label>
                                    <div className="col-8 col-sm-8">
                                        <label className="col-value text-left">
                                            <p className="h5 font-weight-normal">
                                                {moment(this.state.jobApply.created_at).format('YYYY-MM-DD HH:mm')}
                                            </p>
                                        </label>
                                    </div>
                                </div>
                                {this.state.jobApply.job && this.state.jobApply.job.publication_type == 2 ? (
                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label"><p className="h5 font-weight-normal">作業予定日</p></label>
                                    <div className="col-8 col-sm-8">
                                        <label className="col-value text-left">
                                            <p className="h5 font-weight-normal">
                                                {this.state.jobApply.apply_date_raw}
                                            </p>
                                        </label>
                                    </div>
                                </div>
                                ): ''}

                                <div className="form-group row">
                                    <label className="col-4 col-sm-4 col-form-label"><p className="h5 font-weight-normal">編集日</p></label>
                                    <div className="col-8 col-sm-8">
                                        <label className="col-value text-left">
                                            <p class="h5 font-weight-normal">
                                                {moment(this.state.jobApply.updated_at).format('YYYY-MM-DD HH:mm')}
                                            </p>
                                        </label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label"><p className="h5 font-weight-normal">メモ</p></label>
                                    <div className="col-sm-8">
                                        <textarea onChange={this.handleInptChange} name="client_memo" value={this.state.jobApply.client_memo ? this.state.jobApply.client_memo : ""}  className="form-control" rows="8"></textarea>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <button onClick={this.saveData} className="btn btn-primary btn-radius btn-lg m-2"><span className="size-inherit">保存</span></button>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card-footer">
                                    <div className="text-center">
                                        {this.renderChangeStatus()}
                                        {this.renderRejectBtn()}
                                        {this.renderEvaluateStaff()}
                                        {/* <button onClick={this.saveData} className="btn btn-primary btn-radius btn-lg"><span className="size-inherit">保存する</span></button> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="comment-area" className="col-sm-6">
                        <div className="card">
                            <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">コメント</h4></div>
                                <CommentJobApply messages={this.state.messages} jobApply={this.state.jobApply} handleOnLoad={ this.scrollToComment } />
                        </div>
                    </div>
                </div>
            </main>
            <ToastContainer />
        </React.Fragment>
        )
    }
}
